interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, total: number): (number | string)[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("...");
  pages.push(total);
  return pages;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = buildPages(current, total);

  return (
    <nav className="flex items-center justify-center gap-2 mt-10" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="h-9 px-3 text-sm rounded-md border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:border-background-200 disabled:hover:text-foreground-600 cursor-pointer transition-colors whitespace-nowrap"
      >
        上一页
      </button>
      {pages.map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`h-9 min-w-9 px-3 text-sm rounded-md border transition-colors cursor-pointer ${
              p === current
                ? "bg-primary-500 border-primary-500 text-background-50"
                : "bg-background-50 border-background-200 text-foreground-600 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${idx}`} className="px-1 text-foreground-400">
            …
          </span>
        )
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="h-9 px-3 text-sm rounded-md border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:border-background-200 disabled:hover:text-foreground-600 cursor-pointer transition-colors whitespace-nowrap"
      >
        下一页
      </button>
    </nav>
  );
}